import { cn } from "@/libs/utils";
import { IconBaseType } from "@/v2-components/core/icon/type";

export default function WarningIcon({ className }: IconBaseType) {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={cn("size-6", className)}
    >
      <path
        d="M11.9997 14.0385C11.7871 14.0385 11.609 13.9666 11.4655 13.8228C11.3218 13.6791 11.25 13.501 11.25 13.2885V6.28851C11.25 6.07601 11.3219 5.89785 11.4658 5.75401C11.6096 5.61035 11.7878 5.53851 12.0003 5.53851C12.2129 5.53851 12.391 5.61035 12.5345 5.75401C12.6782 5.89785 12.75 6.07601 12.75 6.28851V13.2885C12.75 13.501 12.6781 13.6791 12.5342 13.8228C12.3904 13.9666 12.2122 14.0385 11.9997 14.0385ZM11.9997 18.4615C11.7871 18.4615 11.609 18.3896 11.4655 18.2458C11.3218 18.1019 11.25 17.9238 11.25 17.7113C11.25 17.4986 11.3219 17.3205 11.4658 17.177C11.6096 17.0333 11.7878 16.9615 12.0003 16.9615C12.2129 16.9615 12.391 17.0334 12.5345 17.1773C12.6782 17.3211 12.75 17.4993 12.75 17.7118C12.75 17.9244 12.6781 18.1025 12.5342 18.246C12.3904 18.3897 12.2122 18.4615 11.9997 18.4615Z"
        fill="currentColor"
      />
    </svg>
  );
}
